module.exports = __webpack_public_path__ + "img/partner-4.9b28e5ac.png";